/**
 * User role constants for the application
 */
export const ROLES = {
	ADMIN: "BattAdmin",
	FLEET_MANAGER: "FleetManager",
	DRIVER: "Driver",
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];
